import * as React from 'react';
const PopupContext = React.createContext({
    setBlockClose: () => {
    }
});
export default PopupContext;
